module.exports = __webpack_public_path__ + "assets/facebook-icon.654f18b8.svg";